import lodash from "lodash";
import { CALL_API } from "./constants";
import { RESET_CALL_API } from "./actions";

const initialState = {};

const apiReducer = (state = initialState, action) => {
	if (action.meta && action.meta[CALL_API]) {
		const callApiMetadata = action.meta[CALL_API];

		return {
			...state,
			[callApiMetadata.requestActionType]: lodash.merge(
				callApiMetadata,
				action.error
			)
		};
	}
	if (action.type === RESET_CALL_API) {
		return initialState;
	}

	return state;
};

export default apiReducer;
